import {Component, Input, OnInit} from '@angular/core';
import {TableColumn, UtilityService} from "@app/shared";
import {classToClass} from "class-transformer";

@Component({
  selector: 'app-data-table-export',
  templateUrl: './data-table-export.component.html',
  styleUrls: ['./data-table-export.component.css']
})
export class DataTableExportComponent implements OnInit {

  @Input() value: any[];
  @Input() columns: TableColumn[];
  @Input() exportUsingTableColumn: boolean;
  @Input() exportTableColumns: string[];
  @Input() exportFileName: string;

  DefaultFileName = "File";

  constructor(public utilityService: UtilityService) {
  }


  ngOnInit(): void {
    this.exportFileName = this.exportFileName ? this.exportFileName : this.DefaultFileName;
  }

  onClickExportToExcel(): void {
    let fields: string[];
    if (this.exportUsingTableColumn) {
      fields = [];
      this.columns.forEach(col => { // add fields other than action
        if (col.field.toLowerCase() != "action") {
          fields.push(col.field);
        }
      });
    } else if (this.exportTableColumns) {
      fields = this.exportTableColumns;
    }
    const valueCopy = classToClass(this.value);
    this.utilityService.exportExcel(valueCopy, fields, this.exportFileName);
  }
}
